@if (loading_ots()) {
  <div class="center">
    <ion-spinner></ion-spinner>
    <div>Chargement en cours ...</div>
  </div>
} @else {
  <ion-header>
    <ion-toolbar color="primary">
      <ion-title>Recherche</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="close()">
          <ion-icon name="close" />
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="search-bar-container">
      <div class="search-bar-1">
        <ion-searchbar
          #searchInput
          [(ngModel)]="search_value"
          (ionInput)="filterData($event)"
          show-clear-button="never"
          [placeholder]="'ROUND.RECHERCHE_ROUND' | translate"
        ></ion-searchbar>
        <scan-equipement (equipement)="onScannedEquipement($event)"></scan-equipement>
      </div>
      @if (isSuperAdmin() || !isTogglePortefeuillePerimetreIsoleEnabled()) {
        <ion-button
          class="recherche_elargie"
          [disabled]="!isConnected()"
          [class.hide_search]="search_value.length < 3"
          fill="clear"
          (click)="rechercheElargie()"
        >
          {{ 'RECHERCHE_SITE.SEARCH_BAR.BUTTON' | translate }}
        </ion-button>
      }
    </div>
    <ion-list>
      @if (loading_sites()) {
        <ion-list-header color="primary">Recherche en cours...</ion-list-header>
        <div class="loading_sites">
          <ion-icon name="sync" class="infinite-rotate"></ion-icon>
        </div>
      } @else {
        <ion-list-header color="primary" class="sites-result">
          <span>{{ filteredSites.length }} site(s) trouvé(s) pour « {{ searchText }} »</span>
        </ion-list-header>
        <ion-list>
          @for (site of filteredSites; track dayRoundsTrackBy) {
            <ion-item lines="none" (click)="openDetailsSite(site)" [button]="true">
              <ion-icon name="agenda-localisation" color="primary" slot="start"></ion-icon>
              <ion-label color="primary">{{ site.libelle_long ? site.libelle_long : site.libelle_court }}</ion-label>
              <ion-icon name="chevron-forward-outline" color="primary" slot="end"></ion-icon>
            </ion-item>
          }
        </ion-list>
      }
    </ion-list>
    <ion-list *ngIf="!recherche_elargie">
      <ion-list-header color="primary" class="ots-result">
        <span>{{ filteredOts.length }} OT(s) trouvé(s) pour « {{ searchText }} »</span>
      </ion-list-header>
      <div class="margin" *ngFor="let ot of filteredOts" (click)="openDetailOt(ot)">
        <ion-label>
          {{ ot.dateDebut | date: 'EEEE d MMMM' }}
          <span>prévu à</span>
          {{ ot.dateDebut | date: 'H' }}h{{ ot.dateDebut | date: 'mm' }}
        </ion-label>
        <ot-card [ot]="ot" [isInDayGrid]="true" [displayIconsLabels]="false"></ot-card>
      </div>
    </ion-list>
  </ion-content>
}
